import { Component, OnInit, ViewChild, ElementRef, HostBinding, Input, EventEmitter, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
import { GeocodeService } from 'src/app/services/geocode.service';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
// @ts-ignore
import { LngLat, LngLatBounds } from '!mapbox-gl';
import { Decorable } from 'src/app/types/decorable';
import { SLMap } from 'src/app/model/sl-map';
import { DictHandler, SimpleTHandler } from 'src/app/types/@types/sl-v-types';
import { StreetInputComponent, StreetInputParams } from '../street-input/street-input.component';
import { MapService } from 'src/app/services/map.service';


@Component({
  selector: 'app-cross-streets',
  templateUrl: './cross-streets.component.html',
  styleUrls: ['./cross-streets.component.scss']
})
export class CrossStreetsComponent implements OnInit {
  public street: Decorable = {};
  public model: any = {};
  public searching = false;
  public searchFailed = false;
  public street1: Decorable;
  public street2: Decorable;

  private map: SLMap;
  private okHandler: DictHandler;
  public attribution = '';

  private _value: Decorable;
  @Input()
  public set value(val: Decorable) {
    this._value = val;
    this.valueChange.emit(this._value);
  }
  public get value(): Decorable {
    return this._value;
  }
  @Output()
  public valueChange = new EventEmitter<Decorable>();

  private isActive: boolean = false;
  @HostBinding('class.active') set active(isActive: boolean) {
    isActive = isActive;
    if (this.isActive === true) {
      (this.locSearchGroup.nativeElement.getElementsByClassName('loc-search')[0] as HTMLElement).focus();
    }
  };

  @Input()
  public GetParameterSrc: SimpleTHandler<StreetInputParams> | undefined;


  @ViewChild('streetInput1', { static: true }) streetInput1: StreetInputComponent;
  @ViewChild('streetInput2', { static: true }) streetInput2: StreetInputComponent;

  @ViewChild('locSearchGrp', { static: true }) locSearchGroup: ElementRef<HTMLDivElement>;
  @ViewChild('locSearch', { static: true }) locSearch: ElementRef<HTMLInputElement>;
  // @ViewChild('extentsCB', { static: true }) extentsCB: ElementRef;
  @ViewChild('form', { static: true }) form: ElementRef;
  constructor(private service: GeocodeService, private mapSvc: MapService) { }

  GetSearchParams(): any {
    const params: Decorable = {};
    params.autoComplete = true;
    params.limitExtents = false;
    if (!!this.street1?.point && (typeof this.street1 !== 'string')) {
      if (!!this.street1.center) {
        params.proximity = this.street1.center.join(',');
      }
    } else {
      const mapCenter = this.mapSvc.GetMap().ui.getCenter();
      params.proximity = mapCenter.lng + ',' + mapCenter.lat;
    }
    /*if (this.extentsCB.nativeElement.checked) {
      params.limitExtents = true;
      const bounds: LngLatBounds = this.map.ui.getBounds();
      params.bbox = [
        Math.min(bounds.getWest(), bounds.getEast()),
        Math.min(bounds.getNorth(), bounds.getSouth()),
        Math.max(bounds.getWest(), bounds.getEast()),
        Math.max(bounds.getNorth(), bounds.getSouth())
      ];
    }*/
    return params;
  }


  SetUp(slMap: SLMap, okHandler: DictHandler) {
    this.map = slMap;
    this.okHandler = okHandler;
    this.streetInput1?.Setup();
    this.streetInput2?.Setup();
    this.Focus();
  }
  FindIntersection() {
    const term1 = this.street1;
    const term2 = this.street2;
    if (!term1 || !term2) return;
    if (typeof term1 === 'string') return;
    if (typeof term2 === 'string') return;
    const params = (!!this.GetParameterSrc) ? this.GetParameterSrc() : { autoComplete: true, limitExtents: false }
    this.service.search(`${term1.text} and ${term2.text}`, params).subscribe((response) => {
      if (response?.length > 0) {
        const firstResponse = response[0];
        if (firstResponse?.properties?.accuracy === 'intersection') {
          this.value = firstResponse;
        }
        console.log(response);
      }
    });
  }

  ngOnInit() {

    /*this.extentsCB.nativeElement.addEventListener('onclick', () => {
      this.street1.limitToExtent = this.extentsCB.nativeElement.value;
      this.street2.limitToExtent = this.extentsCB.nativeElement.value;

    });*/

  }
  Focus() {
    window.requestAnimationFrame(() => {
      (this.locSearchGroup.nativeElement.getElementsByClassName('loc-search')[0] as HTMLElement).focus();
    });
  }

}
